var d3 = require('d3');
var Q = require('../../server/unit/qty');

var Model = require('../Model');

var Point = Object.create(Model);

Point.name = 'Point';
Point['@class'] = 'Point';
Point.url = 'point';
Point.fields = {
  name: {},
  index: {},
  parent: {
    hidden: true
  },
  unit: {
    default: 'int',
    validators: {
      // unit: {}
    }
  },
  destUnit: {
    default: null,
    validators: {
      unit: {}
    }
  },
  scale: {
    default: 1
  },
  offset: {
    default: 0
  },
  enumeration: {
    default: null
  },
  writable: {
    default: 0,
  },
  overrides: {
    default: 0,
  },
  // increment: {
  //   default: 1,
  // },
  alarmEnabled: {
    default: 0
  },
  alarmProfile: {
    default: null
  },
  notifyReset: {
    default: 1
  },
  alarmStatus: {

  },
  alarmError: {
    default: 0
  },
  alarmType: {
    default: 'range'
  },
  receivers: {

  },
  trippedTime: {

  },
  resetTime: {
    
  },
  tripTimeout: {
    default: 60
  },
  resetTimeout: {
    default: 60
  },
  alarmHiLimit: {

  },
  alarmLoLimit: {

  },
  validHiLimit: {

  },
  validLoLimit: {

  },
  alarmReverseBoolean: {

  },
  alarmName: {

  },
  alarmDescription: {

  },
  value: {},
  updated: {},
  format: {},
  displayUnit: {},
  excludedHours: {
    default : []
  },
  excludedDaysOfWeek: {
    default : []
  },
  pressureBoolean: {},
  profileReceiverMode: {},
  nextResetDelay: [],
  lastNotificationSentTimestamp: {},
  lastTripIncidentNanoId: {},
  extendedProps: {},
  interval: {},
  overrideActive: {},
  lastTripTimestamp: {},
  influxId: {},
  triggerDelayTimeouts: {},
  resetDelayTimeouts: {},
  acknowledged: {},
  statusIndex: {},
  statusNormalValue: {},
  writeAlternatePoint: {},
  writeGroup: {
    default: null
  },
  calibrationTrackingEnabled: {},
  calibrationOffset: {},
  calibrationLastDate: {},
  deleted: {},
  acknowledgedBy: {},
  acknowledgedTimestap: {},
  querySelector: {},
  jsonPath: {},
  regex: {},
  bacnetWritePriority: {},
};

Point.unitFormatMap = {
  'tempC': 'tempF',
  'temp-C': 'temp-F',
  'degC': 'degF',
  'Pa': 'inH2O',
  'kPa': 'inH2O',
  'L/s': 'gal/min'
};

Point.usaUnitMap = {
  'tempC': 'tempF',
  'temp-C': 'temp-F',
  'degC': 'degF',
  'Pa': 'inH2O',
  'kPa': 'inH2O',
  'L/s': 'gal/min'
};

Point.unitMap = {
  'tempF' : '°F',
  'tempC' : '°C',
  'temp-F' : '°F',
  'temp-C' : '°C',
  'degF' : '°F',
  'degC' : '°C',
  'percent' : '%',
  'inH2O' : 'wc',
  'int' : '',
  'str' : '',
  'datetime': '',
  'gal/min': 'gpm',
  'ft3/m': 'CFM'
};

var defaultNumberFormat = ',.1f';

function isBlankValue (value) {
  return typeof value === 'undefined' || value === null || value === '';
}

function valueTargetUnit (record) {
  record = record || {};

  if (record.destUnit) {
    return record.destUnit;
  }

  if (record.displayUnit) {
    return null;
  }

  return Point.unitFormatMap[record.unit];
}

function coerceValue (record, value) {
  if (typeof value === 'undefined') {
    value = record.value;
  }

  if (typeof value === 'function') {
    value = value();
  }

  return value;
}

Point.applyScaleAndOffset = function applyScaleAndOffset (record, value) {
  value = coerceValue(value);

}

Point.valueSourceToUser = function (record, value, disableFormat) {
  var destUnit;

  record = record || {};

  if (typeof value === 'function') {
    value = value();
  }

  if (isBlankValue(value)) {
    return '';
  }

  destUnit = valueTargetUnit(record);

  if (destUnit && destUnit !== record.unit) {
    try {
      var q = Q(String(value) + ' ' + record.unit);
      value = parseFloat(q.to(destUnit).scalar);
    } catch (e) {
      value = parseFloat(Number(value));
    }
  } else {
    value = parseFloat(Number(value));
  }

  if (record.scale) {
    value = value * record.scale;
  }

  if (disableFormat) {
    return value;
  }

  if (record.format) {
    return d3.format(record.format)(value);
  } else {
    return d3.format(defaultNumberFormat)(value);
  }
};

Point.valueUserToSource = function (record, value) {
  record = record || {};

  if (isBlankValue(value)) {
    return null;
  }

  var thisUnit = valueTargetUnit(record);

  if (!thisUnit || thisUnit === record.unit) {
    return Number(value).toFixed(4);
  }

  try {
    var q = Q(String(value) + ' ' + thisUnit);
    return q.to(record.unit).scalar.toFixed(4);
  } catch (e) {
    return Number(value).toFixed(4);
  }
};

Point.readValue = function readValue (record, disableFormat) {
  var destUnit, value;
  if (typeof record === 'undefined') {
    return '---'
  }
  if (typeof record.value === 'undefined' || record.value === 'undefined' || record.value === null) {
    return '---'
  }

  // Ignore enumeration for boolean units to preserve numeric truthiness
  if (record.enumeration && record.unit !== 'bool') {
    try {
      return record.enumeration[record.value];
    } catch (e) {
      return record.value
    }
  }

  if (record.unit === 'str') {
    return record.value;
  }

  try {
    if (record.unit === 'bool') {
      if (typeof record.value === 'string') {
        if (record.value === 'true') {
          return 1;
        } else if (record.value === 'false') {
          return 0;
        } else {
          return Number(Boolean(Number(record.value)));
        }
      } else if (typeof record.value === 'number') {
        return Number(Boolean(record.value));
      }
    }

    destUnit = valueTargetUnit(record);

    if (destUnit) {
      var q = Q(String(record.value) + ' ' + record.unit);
      value = parseFloat(q.to(destUnit).scalar);
    } else {
      value = parseFloat(Number(record.value));
    }

    if (disableFormat) {
      return value;
    }

    if (record.format) {
      return d3.format(record.format)(value);
    } else {
      return d3.format(defaultNumberFormat)(value);
    }

  } catch (e) {
    return record.value;
  }
};

Point.writeValue = function writeValue (record, value) {
  var thisUnit;
  var scaleValue = function (sourceValue) {
    if (Number(record.scale)) {
      return (1 / Number(record.scale)) * Number(sourceValue);
    } else {
      return Number(sourceValue);
    }
  };

  record = record || {};

  if (record.unit === 'str')  {
    return value;
  } else if (record.unit === 'bool') {
    return Number(Boolean(Number(value)));
  } else if (record.unit === 'int' || record.unit === '%') {
    if (Number(record.scale)) {
      return ((1 / Number(record.scale)) * Number(value)).toFixed(4);
    } else {
      return Number(value).toFixed(4);
    }
  }

  thisUnit = valueTargetUnit(record) || record.unit;
  if (!thisUnit || thisUnit === record.unit) {
    return scaleValue(value);
  }

  try {
    var q = Q(String(value) + ' ' + thisUnit);
    return scaleValue(q.to(record.unit).scalar);
  } catch (e) {
    return scaleValue(value);
  }
};
6
Point.formatUnit = function formatUnit (pointRecord, customUnitMap) {
  var userUnit;
  if (pointRecord.displayUnit) {
    return Point.unitMap[pointRecord.displayUnit] || pointRecord.displayUnit;
  }
  if (pointRecord.destUnit) {
    return Point.unitMap[pointRecord.destUnit] || pointRecord.destUnit;
  }

  if (typeof pointRecord.unit === 'undefined') {
    return '';
  }

  userUnit = Point.usaUnitMap[pointRecord.unit]

  var resultUnit = userUnit || pointRecord.unit;

  if (typeof Point.unitMap[resultUnit] === 'undefined') {
    return resultUnit;
  } else {
    return Point.unitMap[resultUnit];
  }
}

module.exports = Point;
